import React, { useContext, useEffect, useState } from 'react';
import {
  // GET_BUY_HEALTH_POLICY_VAR_DETAILS,
  GET_MEDICAL_QUESTIONS,
  PROPOSER_DROPDOWN_DETAIL,
  GET_DATE_TIME,
  ROLLOVER_COMPANY_LIST,
  GET_BUSINESS_TYPE,
  RENEWAL_MANDATE_DETAILS,
  FINAL_COLLECTION_DATE,
  DEFAULT_BANK_NAME,
  CUSTOMER_BANK_DETAILS,
  CHARACTER_LIMIT_LIST,
} from 'quanta-flows/modules/proposal/health';
import { GET_BUY_HEALTH_POLICY_VAR_DETAILS } from '../queries';
import {CALCULATE_PREMIUM_FOR_PROPOSAL} from '../queries';
import {Loading, Error} from 'quanta-flows/modules/layout';
import { useQuery } from '@apollo/client';
import { QuantaConfigContext,useFetchQuery } from 'quanta-flows';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
  InputGridGroup,
  Text,
  Button,
  SearchResultsModal,
  NotificationList,
} from 'quanta-ui';
import {
  faFileMedical,
  faRupeeSign,
  faSearch,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {ModalMedicalQuestionaire} from 'quanta-flows/modules/proposal/health';
import {
  updateBuyHealthPolicy,
  updatePlanPremium,
} from 'quanta-flows/modules/proposal/health/state';
import { useParams } from 'react-router-dom';
import moment from 'moment';

export default function NomineeDetails({
  proceedToNextStep,
  setProceedToNextStep,
  setParentAlerts,
  setLoadingStep,
  setCustomLoadingMessage,
  planName,
  planCode,
  productCode,
  ...props
}) {
  
  const fetchQuery = useFetchQuery();

  const [alerts, setAlerts] = useState([]);
  const [
    medicalQuestionaireDisplay,
    setMedicalQuestionaireDisplay,
  ] = useState(false);

  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 3 });
  // console.log(props);
  const params = useParams();
  const plan_name = planName ? planName : params?.plan_name;
  const plan_code = planCode ? planCode : params?.plan_code;
  const product_code = "2880"
  let policy_Start_Date_min='';
  const {
    loading: loadingBuyPolicy,
    error: errorBuyPolicy,
    data: dataBuyPolicy,
  } = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first',
  });
  if (dataBuyPolicy) {
    var prembuyHealthPolicy = dataBuyPolicy?.buyHealthPolicy;
    var prempquoteData = prembuyHealthPolicy?.quoteData;
    var premplanData = prembuyHealthPolicy?.planData;
    var plans = premplanData?.plans;
  }
  let Prem_data;
  Prem_data = plans?.find((p) => p.name === plan_name)?.premium
    ?.totalPremium
    //console.log('nominee details premium data',prembuyHealthPolicy.renewalMandateDetails.renewalPaymentMandate)
    let manamount;
    manamount = 1.5 * Prem_data;
   // console.log('manmount data----',manamount)
    let TM;
    TM = 5;
    let DT;
    DT = 'Direct Debit';
    const [renew_man_amount,setrenew_man_amount]= useState(manamount);
    const [termForMandate,settermForMandate]= useState(TM);
    const [Debitype,setDebitype]= useState(DT);
  const [policyStartDate, setPolicyStartDate] = useState();
  const { loading, data: dropDownDetails } = useQuery(
    PROPOSER_DROPDOWN_DETAIL,
    {
      fetchPolicy: 'cache-first',
      variables: {
        productCode: product_code,
      },
    },
  );
  const {
    loading: loadingRollOverCompanyList,
    error: errorRollOverCompanyList,
    data: dataRollOverCompanyList,
  } = useQuery(ROLLOVER_COMPANY_LIST, { fetchPolicy: 'cache-first' });
  const {
    loading: loadingRenewalMandateData,
    data: renewalMandateData,
  } = useQuery(RENEWAL_MANDATE_DETAILS, {
    fetchPolicy: 'cache-first',
    variables: {
      productCode: product_code,
    },
    onError: (err) => {
      setAlerts([
        {
          header: 'No dropdown details',
          id: 1,
          content: (
            <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
              <span>{err.message}</span>
            </div>
          ),
          type: 'error',
          timeout: null,
          disableClose: false,
        },
      ]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  });

  const {
    loading: loadingBusinessType,
    error: errorBusinessType,
    data: dataBusinessType,
  } = useQuery(GET_BUSINESS_TYPE, { fetchPolicy: 'cache-first' });

  const {
    loading: loadingQuestions,
    error: errorQuestions,
    data: dataQuestions,
  } = useQuery(GET_MEDICAL_QUESTIONS, {
    variables: {
      input: {
      productCode: product_code,
    },
  },
  fetchPolicy: 'cache-first',
});
const {
  loading: loadingNameLimit,
  error: errorNameLimit,
  data: dataNameLimit,
} = useQuery(CHARACTER_LIMIT_LIST, {
    fetchPolicy: 'cache-first',
  });

  if (
    loadingBuyPolicy ||
    loading ||
    loadingQuestions ||
    loadingRollOverCompanyList ||
    loadingBusinessType ||
    loadingRenewalMandateData ||
    loadingNameLimit
  ) {
    return (
      <div className="min-h-screen">
        <Loading customMessage={'Fetching nominee details'} />
      </div>
    );
  }
  if (
    errorBuyPolicy ||
    errorQuestions ||
    errorRollOverCompanyList ||
    errorBusinessType ||
    errorNameLimit
  ) {
    return (
      <div className="min-h-screen">
        <Error
          error={
            errorBuyPolicy ||
            errorQuestions ||
            errorRollOverCompanyList ||
            errorBusinessType ||
            errorNameLimit
                    }
        />
      </div>
    );
  }
  const { buyHealthPolicy } = dataBuyPolicy;
  const { businessTypeList } = dataBusinessType;
  const { rolloverCompanyList } = dataRollOverCompanyList;
  const {
    nomineeDetails,
    prevInsuranceDetails,
    renewalMandateDetails,
  } = buyHealthPolicy;
  const {
    PRD_NomiRelationWithMemb,
    PRD_ApointRelationWithMinNomi,
  } = dropDownDetails;
  const {
    PRD_TermForMandate,
    PRD_RenewalPaymentMandateTakenInTheNameOf,
    typeOfDebit,
    destinationBankAccountType,
  } = renewalMandateData;
  const { productQuestionList } = dataQuestions;
  const { characterLimitList } = dataNameLimit;

  const MINOR_THRESHOLD_AGE = 18;

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
          `${returnType}`
        ]
      : '';
  };

  const reformData = (val, returnType) => {
    return val && val.toString().trim() !== '' ? val : returnType;
  };

  const getInitObject = () => {
    let initObj = {};
    nomineeDetails.forEach((nominee) => {
      const prevInsured = prevInsuranceDetails?.find(
        (prevInsured) =>
          prevInsured?.insuredRelationship?.toLowerCase() ===
          nominee?.relationship?.toLowerCase(),
      );
      initObj[nominee.relationship] = {
        name: nominee.name ? nominee.name : '',
        dob: nominee.dob ? nominee.dob : '',
        relationshipWithInsured: nominee.relationshipWithInsured
          ? nominee.relationshipWithInsured
          : '',
        relationshipWithAppointee: nominee.relationshipWithAppointee
          ? nominee.relationshipWithAppointee
          : '',
        nameOfAppointee: nominee.nameOfAppointee
          ? nominee.nameOfAppointee
          : '',
        prevInsuranceDetails: {
          prevInsurerName:
            prevInsured?.prevInsurerName !== undefined
              ? prevInsured?.prevInsurerName
              : '',
          prevPolicyNo:
            prevInsured?.prevPolicyNo !== undefined
              ? prevInsured?.prevPolicyNo
              : '',
          prevPolicyStartDate:
            prevInsured?.prevPolicyStartDate !== undefined
              ? prevInsured?.prevPolicyStartDate
              : '',
          prevPolicyEndDate:
            prevInsured?.prevPolicyEndDate !== undefined
              ? prevInsured?.prevPolicyEndDate
              : '',
          prevPolicySI:
            prevInsured?.prevPolicySI !== undefined
              ? prevInsured?.prevPolicySI
              : '',
          prevClaimLodged:
            prevInsured?.prevClaimLodged !== undefined
              ? prevInsured?.prevClaimLodged
              : '',
          claimAmount:
            prevInsured?.claimAmount !== undefined
              ? prevInsured?.claimAmount
              : '',
          cbAmount:
            prevInsured?.cbAmount !== undefined
              ? prevInsured?.cbAmount
              : '',
          insuredRelationship: nominee?.relationship
            ? nominee?.relationship
            : '',
        },
      };
    });
    initObj.sameNomineeForAllInsured =
      buyHealthPolicy.sameNomineeForAllInsured;
    initObj.isHealthDeclarationSelected = buyHealthPolicy?.isHealthDeclarationSelected
      ? buyHealthPolicy?.isHealthDeclarationSelected
      : 'No';
    initObj.renewalPaymentMandate = false,
   //   renewalMandateDetails?.renewalPaymentMandate === false
     // ? renewalMandateDetails?.renewalPaymentMandate
       //: buyHealthPolicy?.quoteData?.cover?.tenure?.toLowerCase() =="1 year" ||buyHealthPolicy?.quoteData?.cover?.tenure?.toString() =="1"
       //?true
      //  : buyHealthPolicy?.quoteData?.cover?.tenure?.toString() =="1"
      //  ? true
        //:false;
    initObj.renewalPaymentMandateTakenInNameOf = renewalMandateDetails?.renewalPaymentMandateTakenInNameOf
      ? renewalMandateDetails?.renewalPaymentMandateTakenInNameOf
      : PRD_RenewalPaymentMandateTakenInTheNameOf.length > 0
      ? PRD_RenewalPaymentMandateTakenInTheNameOf[0].code
      : '';
    initObj.termForMandateOpted = renewalMandateDetails?.termForMandateOpted
      ? renewalMandateDetails?.termForMandateOpted
      : '';
    initObj.typeOfDebit = renewalMandateDetails?.typeOfDebit
      ? renewalMandateDetails?.typeOfDebit
      : '';
    initObj.accountNumber = renewalMandateDetails?.accountNumber
      ? renewalMandateDetails?.accountNumber
      : '';
    initObj.destinationBankName = renewalMandateDetails?.destinationBankName
      ? renewalMandateDetails?.destinationBankName
      : '';
    initObj.destinationIfscCode = renewalMandateDetails?.destinationIfscCode
      ? renewalMandateDetails?.destinationIfscCode
      : '';
    initObj.destinationMicrCode = renewalMandateDetails?.destinationMicrCode
      ? renewalMandateDetails?.destinationMicrCode
      : '';
    initObj.destinationBranchName = renewalMandateDetails?.destinationBranchName
      ? renewalMandateDetails?.destinationBranchName
      : '';
    initObj.mandateAmount = renewalMandateDetails?.mandateAmount
      ? renewalMandateDetails?.mandateAmount
      : '';
    initObj.finalCollectionDate = renewalMandateDetails?.finalCollectionDate
      ? renewalMandateDetails?.finalCollectionDate
      : '';
    initObj.destinationBankAccountType = renewalMandateDetails?.destinationBankAccountType
      ? renewalMandateDetails?.destinationBankAccountType
      : destinationBankAccountType
      ? destinationBankAccountType[0]?.code
      : '';

    return initObj;
  };

  const initialValues = getInitObject();

  const validate = (values) => {
    let errors = {};
    let dcount = 0;
    let pcount = 0;
    const firstNameValue = characterLimitList?.find(
      (characterLimit) =>
        characterLimit.code.toLowerCase() === 'first name',
    );
    nomineeDetails.forEach((nominee) => {
      errors[`${nominee.relationship}`] = {};
      errors[`${nominee.relationship}`].prevInsuranceDetails = {};
      if (!values[`${nominee.relationship}`].name) {
        errors[`${nominee.relationship}`].name = '* Required';
      }
      if (
        values[`${nominee.relationship}`].name &&
        values[`${nominee.relationship}`].name.match(/\d/)
      ) {
        errors[`${nominee.relationship}`].name =
          '* Name cannot be alphanumeric';
        } else if (
          values[`${nominee.relationship}`].name.length >
          firstNameValue.value
        ) {
          errors[
            `${nominee.relationship}`
          ].name = `* Name cannot be greater than ${firstNameValue.value} characters`;
      }
      if (!values[`${nominee.relationship}`].dob) {
        errors[`${nominee.relationship}`].dob = '* Required';
      }
      if (values[`${nominee.relationship}`].dob) {
        if (
          moment(
            values[`${nominee.relationship}`].dob,
            'DD/MM/YYYY',
          ).isAfter()
        ) {
          errors[`${nominee.relationship}`].dob =
            '* Date of Birth cannot be a future date';
        }
      }
      if (
        !values[`${nominee.relationship}`].relationshipWithInsured
      ) {
        errors[`${nominee.relationship}`].relationshipWithInsured =
          '* Required';
      }

      if (
        values[`${nominee.relationship}`].dob &&
        moment(new Date(), 'DD/MM/YYYY').diff(
          moment(values[`${nominee.relationship}`].dob, 'DD/MM/YYYY'),
          'years',
        ) < MINOR_THRESHOLD_AGE
      ) {
        if (!values[`${nominee.relationship}`].nameOfAppointee) {
          errors[`${nominee.relationship}`].nameOfAppointee =
            '* Required';
          } else if (
            !values[`${nominee.relationship}`].nameOfAppointee.match(
              /^[a-zA-Z ]*$/,
            )
          ) {
            errors[`${nominee.relationship}`].nameOfAppointee =
              '* Name can be alphabets only';
          } else if (
            values[`${nominee.relationship}`].nameOfAppointee.length >
            firstNameValue.value
          ) {
            errors[
              `${nominee.relationship}`
            ].nameOfAppointee = `* Name cannot be greater than ${firstNameValue.value} characters`;
        }
        if (
          !values[`${nominee.relationship}`].relationshipWithAppointee
        ) {
          errors[
            `${nominee.relationship}`
          ].relationshipWithAppointee = '* Required';
        }
      }
        if (
            values[`${nominee.relationship}`].prevInsuranceDetails
              .prevInsurerName !== ''
          ) {
              dcount = dcount + 1;
          }
      /**Validations for previous insurance details */
      pcount = pcount + 1;
    });
    //console.log('dcount data',dcount)
    if (buyHealthPolicy?.quotationType.toLowerCase() !== 'new business')
    {
    if (dcount === 0)
        {
         // console.log('inside dcount data if',dcount)
          nomineeDetails.forEach((nominee) => {
            errors[`${nominee.relationship}`].prevInsuranceDetails = {}
          errors[`${nominee.relationship}`].prevInsuranceDetails
          .prevInsurerName =
          '* For Roll Over atleast 1 Previous insurance details is Required';
          });
        }
    } 
    nomineeDetails.forEach((nominee) => {
      //errors[`${nominee.relationship}`].prevInsuranceDetails = {}
      if (dcount >= 1)
      {errors[`${nominee.relationship}`].prevInsuranceDetails = {}
          if (values[`${nominee.relationship}`].prevInsuranceDetails
          .prevInsurerName !== '')
          {
      if (
        getDomainData(
          businessTypeList,
          buyHealthPolicy?.quotationType,
          'code',
          'value',
        )?.toLowerCase() !== 'new business' ||
        Object.keys(
          values[`${nominee.relationship}`].prevInsuranceDetails,
        ).find(
          (k) =>
            k?.toLowerCase() !== 'prevclaimlodged' &&
            k?.toLowerCase() !== 'insuredrelationship' &&
            k?.toLowerCase() !== 'cbpct' &&
            values[`${nominee.relationship}`].prevInsuranceDetails[k],
        )
      ) {
        if (
          !values[`${nominee.relationship}`].prevInsuranceDetails
            .prevInsurerName
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevInsurerName = '* Required';
        }
        if (
          values[`${nominee.relationship}`].prevInsuranceDetails
            .prevInsurerName &&
          !getDomainData(
            rolloverCompanyList,
            values[`${nominee.relationship}`].prevInsuranceDetails
              .prevInsurerName,
            'code',
            'value',
          )
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevInsurerName =
            '* Invalid Insurer';
        }
        if (
          !values[`${nominee.relationship}`].prevInsuranceDetails
            .prevPolicyNo
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyNo = '* Required';
        }
        if (
          values[`${nominee?.relationship}`]?.prevInsuranceDetails
            ?.prevPolicyNo &&
          !values[
            `${nominee?.relationship}`
          ]?.prevInsuranceDetails?.prevPolicyNo?.match(
            /^[a-zA-Z0-9]+$/,
          )
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyNo =
            '* Policy Number can be alphanumeric only';
        }
        if (
          !values[`${nominee.relationship}`].prevInsuranceDetails
            .prevPolicyStartDate
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyStartDate = '* Required';
        }
        if (
          moment(
            values[`${nominee.relationship}`]?.prevInsuranceDetails
              ?.prevPolicyStartDate,
            'DD/MM/YYYY',
          ).isAfter()
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyStartDate =
            '* Cannot accept future date';
        } else if (
          values[`${nominee.relationship}`]?.prevInsuranceDetails
            ?.prevPolicyEndDate &&
          moment(
            values[`${nominee.relationship}`]?.prevInsuranceDetails
              ?.prevPolicyStartDate,
            'DD/MM/YYYY',
          )?.isAfter(
            moment(
              values[`${nominee.relationship}`]?.prevInsuranceDetails
                ?.prevPolicyEndDate,
              'DD/MM/YYYY',
            ),
          )
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyStartDate =
            '* Policy Start date cannot be greater than the Expiry date';
        }
        let days= new Date();
            days.setDate(days.getDate() + 44)
        // console.log("days",days)
        if (
          moment(
            values[`${nominee.relationship}`]?.prevInsuranceDetails
              ?.prevPolicyEndDate,
            'DD/MM/YYYY',
          ) >days
          // .isAfter()
          // >days
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyEndDate =
                '* Policy Expiry date cannot be more than 45days from current date';
        }
        if ( 
          moment(
            values[`${nominee.relationship}`]?.prevInsuranceDetails
              ?.prevPolicyEndDate,
            'DD/MM/YYYY',
          ) .isBefore(
            moment(),'dates'
          )
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyEndDate =
            '* Previous insurance policy end date cannot be less than current date';
        }
        if (
          !values[`${nominee.relationship}`].prevInsuranceDetails
            .prevPolicyEndDate
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyEndDate = '* Required';
        } else if (
          values[`${nominee.relationship}`]?.prevInsuranceDetails
            ?.prevPolicyStartDate &&
          moment(
            values[`${nominee.relationship}`]?.prevInsuranceDetails
              ?.prevPolicyEndDate,
            'DD/MM/YYYY',
          )?.isBefore(
            moment(
              values[`${nominee.relationship}`]?.prevInsuranceDetails
                ?.prevPolicyStartDate,
              'DD/MM/YYYY',
            ),
          )
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicyEndDate =
            '* Policy Expiry date cannot be less than the Start date';
        }
        if (
          !values[`${nominee.relationship}`].prevInsuranceDetails
            .prevPolicySI
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicySI = '* Required';
        }
        if (
          values[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicySI
            ?.toString()
            .startsWith('0')
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevPolicySI =
            '* Sum Insured cannot be equal to or start with 0';
        }
        if (
          !values[`${nominee.relationship}`].prevInsuranceDetails
            .prevClaimLodged
        ) {
          errors[
            `${nominee.relationship}`
          ].prevInsuranceDetails.prevClaimLodged = '* Required';
        }
      }
      if (
        values[
          `${nominee.relationship}`
        ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
          'yes' &&
        !values[`${nominee.relationship}`].prevInsuranceDetails
          .claimAmount
      ) {
        errors[
          `${nominee.relationship}`
        ].prevInsuranceDetails.claimAmount = '* Required';
      }
      if (
        values[
          `${nominee.relationship}`
        ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
          'yes' &&
        values[
          `${nominee.relationship}`
        ].prevInsuranceDetails.claimAmount
          ?.toString()
          ?.startsWith('0')
      ) {
        errors[
          `${nominee.relationship}`
        ].prevInsuranceDetails.claimAmount =
          '* Claim Amount cannot be equal to or start with 0';
      }
      // if (
      //   values[
      //     `${nominee.relationship}`
      //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
      //     'yes' &&
      //   !values[`${nominee.relationship}`].prevInsuranceDetails
      //     .cbAmount
      // ) {
      //   errors[
      //     `${nominee.relationship}`
      //   ].prevInsuranceDetails.cbAmount = '* Required';
      // }
      if (
        values[
          `${nominee.relationship}`
        ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
          'yes' &&
        values[
          `${nominee.relationship}`
        ].prevInsuranceDetails.cbAmount
          ?.toString()
          ?.startsWith('0')
      ) {
        errors[
          `${nominee.relationship}`
        ].prevInsuranceDetails.cbAmount =
          '* Cumulative Bonus Amt cannot be equal to or start with 0';
      }
  }
}
    });
    if(buyHealthPolicy.quotationType.toString() === 'Roll Over')
    {
    for(let i=0;i<=pcount-1;i++)
    { 
      if(buyHealthPolicy.insuredDetails[i].isPortabilityRequired.toString() === 'true')
      { 
        if(
        values[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails
          .prevInsurerName === '')
          { 
            errors[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails
          .prevInsurerName =
          '* portablity checked against this member kindly fill his/her previous insurance details';
          }
          if (
            !values[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails
              .prevPolicyNo
          ) {
            errors[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevPolicyNo = '* Required';
          }
          if (
            values[buyHealthPolicy.insuredDetails[i].relationship]?.prevInsuranceDetails
              ?.prevPolicyNo &&
            !values[buyHealthPolicy.insuredDetails[i].relationship]?.prevInsuranceDetails?.prevPolicyNo?.match(
              /^[a-zA-Z0-9]+$/,
            )
          ) {
            errors[buyHealthPolicy.insuredDetails[i].relationship].prevInsuranceDetails.prevPolicyNo =
              '* Policy Number can be alphanumeric only';
          }
      }
    }
  }
    let error_count = 0;
    nomineeDetails.forEach((nominee) => {
      if (errors[`${nominee.relationship}`].prevInsuranceDetails) {
        const { prevInsuranceDetails, ...errorsObj } = errors[
          `${nominee.relationship}`
        ];
        error_count +=
          Object.keys(errorsObj).length +
          Object.keys(prevInsuranceDetails).length;
      } else {
        error_count += Object.keys(errors[`${nominee.relationship}`])
          .length;
      }
    });
    if (error_count === 0) {
      errors = {};
    }
    /* Validations for Renew Mandate */
    /*if (values.renewalPaymentMandate === true) {
      if (!values.termForMandateOpted) {
        errors.termForMandateOpted = '* Required';
      }
      if (!values.typeOfDebit) {
        errors.typeOfDebit = '* Required';
      }
      if (!values.accountNumber) {
        errors.accountNumber = '* Required';
      }
      if (
        getDomainData(
          typeOfDebit,
          values.typeOfDebit,
          'code',
          'value',
        )?.toLowerCase() === 'nach'
      ) {
        if (!values.destinationIfscCode) {
          errors.destinationIfscCode = '* Required';
        }
        if (
          values?.destinationIfscCode &&
          !values?.destinationIfscCode.match(/^[a-zA-Z0-9]+$/)
          ) {
          errors.destinationIfscCode =
          '* IFSC Code cannot contain special characters';
          }
          if (
          values.destinationIfscCode &&
          (!values.destinationBankName ||
          !values.destinationBranchName)&&
          values?.destinationIfscCode.match(/^[a-zA-Z0-9]+$/)
          ) {
          errors.destinationIfscCode =
          '* Click the Search icon to fetch Bank Name and Branch Name';
          }
        if (
          values?.destinationMicrCode &&
          !values?.destinationMicrCode.match(/^[a-zA-Z0-9]+$/)
          ) {
          errors.destinationMicrCode =
          '* MICR Code cannot contain special characters';
          }
        if (!values.destinationBankAccountType) {
          errors.destinationBankAccountType = '* Required';
        }
      }
      if (!values.mandateAmount) {
        errors.mandateAmount = '* Required';
      }
    }*/
    return errors;
  };

  const NomineeForm = ({
    validate,
    productQuestionList,
    medicalQuestionaireOpenMode,
  }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [ifscModalDisplay, showIfscModal] = useState(false);
    const [loadingIfscCodeData, setLoadingIfscCodeData] = useState(
      false,
    );
    const [ifscCodeOutput, setIfscCodeOutput] = useState([]);
    const [bankMetaMessage, setBankMetaMessage] = useState(null);
    const [
      loadingIfscModalDisplay,
      setLoadingIfscModalDisplay,
    ] = useState(false);
    const [searchStringIfsc, setSearchStringIfsc] = useState('');
    const [onDataUpdate, setOnUpdate] = useState(null);
    const { branding } = useContext(QuantaConfigContext);
    const [
      loadingFinalCollectionDate,
      setLoadingFinalCollectionDate,
    ] = useState(false);
    const [
      loadingDefaultBankName,
      setLoadingDefaultBankName,
    ] = useState(false);
    const [errors, setErrors] = useState({ ifsc: '' });
    const [alerts, setAlerts] = useState([]);

    const colSpanParams = useResponsiveParams({
      for_mobile: { searchString: 8, button: 2 },
      for_desktop: { searchString: 4, button: 1 },
    });

    const changeInputType = useResponsiveParams({
      for_mobile: 'input-lookup',
      for_desktop: 'text',
    });

    useEffect(() => {
      let isMounted = false;
      return () => isMounted;
    }, [medicalQuestionaireDisplay]);

    const onIfscSearch = async (val, setFieldValue) => {
      if (val?.toString()?.length > 0) {
        try {
          setIfscCodeOutput([]);
          const ifscLookupQuery = fetchQuery({
            query: CUSTOMER_BANK_DETAILS,
            variables: {
              filter: {
                ifscCode: val?.toString(),
                },
              },
                      });
          setLoadingIfscCodeData(true);
          const { data } = await ifscLookupQuery;
          setLoadingIfscCodeData(false);
          setIfscCodeOutput(data?.bankInfo);
          setBankMetaMessage(data?._bankInfo_meta?.metaMessage);
        } catch (error) {
          setErrors({
            ...errors,
            ifsc: error.message,
          });
          setLoadingIfscCodeData(false);
          setIfscCodeOutput([]);
          setBankMetaMessage(null);
        }
      }
    };

    const icon_idle = (
      <img
        src={branding.illustration.no_data}
        alt="no data"
        className="lg:w-80 lg:h-80 w-64 h-64 opacity-50"
      />
    );

    const searchInput = {
      flow: 'cols',
      repeat: 5,
      data:
        changeInputType === 'text'
          ? [
              {
                type: 'text',
                name: 'searchString',
                size: 'full',
                colSpan: colSpanParams.searchString,
              },
              {
                type: 'submit',
                size: 'full',
                colSpan: colSpanParams.button,
                iconPre: <FontAwesomeIcon icon={faSearch} />,
                children: 'Search',
              },
            ]
          : [
              {
                type: 'input-lookup',
                name: 'searchString',
                size: 'full',
                colSpan: colSpanParams.searchString,
                onLookup: onIfscSearch,
              },
            ],
      initialValues: {
        searchString: searchStringIfsc,
      },
      validate: (values) => {
        const errors = {};
        if (!values.searchString) errors.searchString = '* Required';
        return errors;
      },
      onSearch: async (values) => {
        try {
          setIfscCodeOutput([]);
          let queryOutput = fetchQuery({
            query: CUSTOMER_BANK_DETAILS,
            variables: {
              filter: {
                ifscCode: values.searchString,
                },
              },
          });
          setLoadingIfscCodeData(true);
          let { data } = await queryOutput;
          setLoadingIfscCodeData(false);
          setIfscCodeOutput(data.bankInfo);
          setBankMetaMessage(data._bankInfo_meta.metaMessage);
        } catch (error) {
          setErrors({
            ...errors,
            ifsc: error.message,
          });
          setLoadingIfscCodeData(false);
          setIfscCodeOutput([]);
          setBankMetaMessage(null);
        }
      },
    };

    const searchResults = {
      data: ifscCodeOutput,
      onIdle: () => {
        if (loadingIfscCodeData) {
          return <Loading />;
        } else if (searchStringIfsc === '') {
          return icon_idle;
        }
        return undefined;
      },
      columns: [
        {
          Header: 'IFSC Code',
          accessor: 'ifsc_code',
        },
        {
          Header: 'Bank Name',
          accessor: 'name',
        },
        {
          Header: 'Branch Name',
          accessor: 'branch_name',
        },
      ],
      list: ifscCodeOutput.map((data) => {
        return {
          title: `${data.ifsc_code}`,
          subtitle: `${data.branch_name}`,
          onClick: () => {
            onDataUpdate(data);
            showIfscModal(false);
            document.body.classList.remove('overflow-y-hidden');

          },
        };
      }),
      sortBy: { id: 'ifsc_code', desc: false },
    };

    const onClose = () => {
      showIfscModal(false);
    };

    const onNoResultsFound = () => {
      return errors.ifsc;
    };

    const onMessage = () => {
      return (
        bankMetaMessage &&
        bankMetaMessage.type &&
        bankMetaMessage.message && (
          <Text severity={bankMetaMessage.type} className="space-x-1">
            <div className="flex flex-row">
              <div>
                <FontAwesomeIcon
                  icon={
                    bankMetaMessage.type === 'info'
                      ? faExclamationCircle
                      : bankMetaMessage.type === 'warning'
                      ? faExclamationTriangle
                      : faTimesCircle
                  }
                  className={`mr-1 text-${bankMetaMessage.type}`}
                />
              </div>
              <div>{bankMetaMessage.message}</div>
            </div>
          </Text>
        )
      );
    };

    const paginationInput = {
      offset: 0,
      PAGE_SIZE: 4,
    };

    const healthDeclarationData = [
      {
        title: (
          <span className="flex flex-col space-y-3 mt-6">
            <Text severity="info" type="title">
              Health Declaration
            </Text>
            {/* <Text type="label" className="text-base text-black">
              Has any person proposed to be insured under the policy
              suffered from any medical conditions or disabilities of
              health problems listed below or has been hospitalised or
              has had any surgical operation be it intermittent
              recurring or otherwise?
            </Text> */}
            <Text type="label" className="text-base text-black">
            Any of the Insured member/s has medical condition or in not in good health?   
            </Text>
          </span>
        ),
        grid_data: [
          {
            type: 'radiogroup',
            disabledGlobal:
              buyHealthPolicy?.proposalNumber.length > 0,
            name: 'isHealthDeclarationSelected',
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
          },
        ],
      },
    ];

    const renewalMandateDetails = [
      {
        title: (
          <Text severity="info" type="large">
            Renewal Mandate
          </Text>
        ),
        grid_data: loadingDefaultBankName
          ? [
              {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <div className="flex items-center justify-center">
                      <Loading customMessage={'Fetching Bank Name'} />
                    </div>
                  );
                },
              },
            ]
          : loadingFinalCollectionDate
          ? [
              {
                type: 'render',
                colSpan: repeat,
                component: () => {
                  return (
                    <div className="flex items-center justify-center">
                      <Loading
                        customMessage={
                          'Fetching final collection date'
                        }
                      />
                    </div>
                  );
                },
              },
            ]
          : [
              {
                type: 'checkbox',
                name: 'renewalPaymentMandate',
                // checked:buyHealthPolicy?.quoteData?.cover.tenure?.toString() =='1 Year'||buyHealthPolicy?.quoteData?.cover?.tenure?.toString() =="1",
                disabled: buyHealthPolicy?.proposalNumber.length > 0 ||(buyHealthPolicy?.quoteData?.cover.tenure?.toString() !=='1 Year'
                 && buyHealthPolicy?.quoteData?.cover?.tenure?.toString() !="1"),
                label: (
                  <Text>
                    Do you want to set up a renewal payment mandate in
                    the name of{' '}
                    {
                      PRD_RenewalPaymentMandateTakenInTheNameOf[0]
                        ?.value
                    }
                    ?
                  </Text>
                ),
                disabled:true,
                colSpan: repeat,
                onDataChange: (val, setFieldValue) => {
                 if (val === true)
                  setrenew_man_amount(manamount)
                  
                  else
                  setrenew_man_amount('')
                },
              },
              0 // renew mandate - 42996
                ? {
                    type: 'select',
                    name: 'termForMandateOpted',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0,
                    label: (
                      <div>
                        Term for Mandate - Opted (Times){' '}
                        <Text severity="error">
                          {values.renewalPaymentMandate ? '*' : ''}
                        </Text>
                      </div>
                    ),
                    onDataChange: async (val, setFieldValue) => {
                      if (val?.toString()?.length > 0) {
                        try {
                          const finalCollectionDate = fetchQuery({
                            query: FINAL_COLLECTION_DATE,
                            fetchPolicy: 'network-only',
                            variables: {
                              input: {
                                MandateOptedTerm: val?.toString(),
                                },
                              },
                          });
                          setLoadingFinalCollectionDate(true);
                          const { data } = await finalCollectionDate;
                          setLoadingFinalCollectionDate(false);
                          setFieldValue(
                            'finalCollectionDate',
                            data?.finalCollectionDate?.date,
                          );
                        } catch (error) {
                          setLoadingDefaultBankName(false);
                          setAlerts([
                            {
                              header:
                                'Error fetching final collection date',
                              id: 1,
                              content: (
                                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                  <span>{error.message}</span>
                                </div>
                              ),
                              type: 'error',
                              timeout: null,
                              disableClose: false,
                            },
                          ]);
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                        }
                      }
                    },
                    data: PRD_TermForMandate
                      ? PRD_TermForMandate?.map((term) => {
                          return {
                            label: term ? term.value : '',
                            value: term ? term.code : '',
                          };
                        })
                      : [],
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'select',
                    name: 'typeOfDebit',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0,
                    label: (
                      <div>
                        Type of Debit{' '}
                        <Text severity="error">
                          {values.renewalPaymentMandate ? '*' : ''}
                        </Text>
                      </div>
                    ),
                    data: typeOfDebit
                      ? typeOfDebit?.map((debitType) => {
                          return {
                            label: debitType.value
                              ? debitType.value
                              : '',
                            value: debitType.code
                              ? debitType.code
                              : '',
                          };
                        })
                      : [],
                    onDataChange: async (val, setFieldValue) => {
                      if (
                        getDomainData(
                          typeOfDebit,
                          val?.toString(),
                          'code',
                          'value',
                        )?.toLowerCase() === 'direct debit'
                      ) {
                        try {
                          const defaultBankName = fetchQuery({
                            query: DEFAULT_BANK_NAME,
                            fetchPolicy: 'cache-first',
                          });
                          setLoadingDefaultBankName(true);
                          const { data } = await defaultBankName;
                          setLoadingDefaultBankName(false);
                          setFieldValue(
                            'destinationBankName',
                            data?.defaultBankName?.code,
                          );
                        } catch (error) {
                          setLoadingDefaultBankName(false);
                          setAlerts([
                            {
                              header:
                                'Error fetching default bank name',
                              id: 1,
                              content: (
                                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                  <span>{error.message}</span>
                                </div>
                              ),
                              type: 'error',
                              timeout: null,
                              disableClose: false,
                            },
                          ]);
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                        }
                      }
                    },
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'number',
                    name: 'accountNumber',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0,
                    onKeyDown: (evt) =>
                      (evt.key === 'e' ||
                        evt.key === '-' ||
                        evt.key === '.') &&
                      evt.preventDefault(),
                    label: (
                      <div>
                        Destination Bank Account Number/ Legal Account
                        Number <Text severity="error">*</Text>
                      </div>
                    ),
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'text',
                    name: 'destinationBankName',
                    disabled: true,
                    label: (
                      <div>
                        Direct Debit/ NACH - Destination Bank Name{' '}
                        <Text severity="error">*</Text>
                      </div>
                    ),
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'input-lookup',
                    size: 'large',
                    name: 'destinationIfscCode',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0 ||
                      values.typeOfDebit?.toLowerCase() !== 'nach',
                    label: (
                      <div>
                        Destination Bank IFSC code{' '}
                        <Text severity="error">
                          {values.typeOfDebit?.toLowerCase() ===
                          'nach'
                            ? '*'
                            : ''}
                        </Text>
                      </div>
                    ),
                    loading: loadingIfscModalDisplay,
                    onLookup: async (val, setFieldValue) => {
                      if (val?.toString()?.length > 0) {
                        setOnUpdate((_) => {
                          const newFunc = (data) => {
                            setFieldValue(
                              'destinationBranchName',
                              reformData(data?.branch_name, ''),
                            );
                            setFieldValue(
                              'destinationIfscCode',
                              reformData(data?.ifsc_code, ''),
                            );
                            setFieldValue(
                              'destinationBankName',
                              reformData(data?.name, ''),
                            );
                            setFieldValue(
                              'destinationMicrCode',
                              reformData(data?.micr_code, ''),
                            );
                          };
                          return newFunc;
                        });
                        setSearchStringIfsc(val);
                        try {
                          const ifscCodeOutputQuery = fetchQuery({
                            query: CUSTOMER_BANK_DETAILS,
                            variables: {
                              filter: {
                                ifscCode: val,
                                },
                              },
                          });
                          setIfscCodeOutput([]);
                          setLoadingIfscModalDisplay(true);
                          showIfscModal(true);
                          setLoadingIfscModalDisplay(false);
                          setLoadingIfscCodeData(true);
                          let { data } = await ifscCodeOutputQuery;
                          setLoadingIfscCodeData(false);
                          setIfscCodeOutput(data?.bankInfo);
                        } catch (error) {
                          setErrors({
                            ...errors,
                            ifsc: error.message,
                          });
                          setFieldValue('destinationBranchName', '');
                          setFieldValue('destinationBankName', '');
                          setFieldValue('destinationMicrCode', '');
                        }
                      }
                    },
                    onDataChange: (_, setFieldValue) => {
                      setFieldValue('destinationBranchName', '');
                      setFieldValue('destinationBankName', '');
                      setFieldValue('destinationMicrCode', '');
                    },
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'text',
                    name: 'destinationMicrCode',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0 ||
                      values.typeOfDebit?.toLowerCase() !== 'nach',
                    label: (
                      <div>
                        Destination Bank MICR code{' '}
                        <Text severity="error"></Text>
                      </div>
                    ),
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'text',
                    name: 'destinationBranchName',
                    disabled: true,
                    label: (
                      <div>
                        Branch Name{' '}
                        <Text severity="error">
                          {values.typeOfDebit?.toLowerCase() ===
                          'nach'
                            ? '*'
                            : ''}
                        </Text>
                      </div>
                    ),
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'number',
                    name: 'mandateAmount',
                    iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0,
                    onKeyDown: (evt) =>
                      (evt.key === 'e' || evt.key === '-') &&
                      evt.preventDefault(),
                    label: (
                      <div>
                        Mandate Amount <Text severity="error">*</Text>
                      </div>
                    ),
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'date',
                    name: 'finalCollectionDate',
                    disabled: true,
                    label: (
                      <div>
                        Final Collection Date{' '}
                        <Text severity="error">*</Text>
                      </div>
                    ),
                  }
                : null,
              0 // renew mandate - 42996
                ? {
                    type: 'select',
                    name: 'destinationBankAccountType',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0,
                    label: (
                      <div>
                        Destination Bank Account Type{' '}
                        <Text severity="error">*</Text>
                      </div>
                    ),
                    data: destinationBankAccountType
                      ? destinationBankAccountType?.map(
                          (bankAccType) => {
                            return {
                              label: bankAccType.value
                                ? bankAccType.value
                                : '',
                              value: bankAccType.code
                                ? bankAccType.code
                                : '',
                            };
                          },
                        )
                      : [],
                  }
                : null,
            ].filter((d) => d),
      },
    ];

    const prevInsuredDetailsData = nomineeDetails
      ? nomineeDetails?.map((nominee) => {
          return {
            title: (
              <>
                <Text severity="info" type="large">
                  {nominee.relationship}-Previous Insurance Policy and
                  Claims{' '}
                </Text>
                {(getDomainData(
                  businessTypeList,
                  buyHealthPolicy?.quotationType,
                  'code',
                  'value',
                )?.toLowerCase() !== 'new business' ||
                  Object.keys(
                    values[`${nominee.relationship}`]
                      .prevInsuranceDetails,
                  ).find(
                    (k) =>
                      k?.toLowerCase() !== 'prevclaimlodged' &&
                      k?.toLowerCase() !== 'insuredrelationship' &&
                      k?.toLowerCase() !== 'cbpct' &&
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails[k],
                  )) && (
                  <Text severity="error" type="title">
                    *
                  </Text>
                )}
              </>
            ),
            size: 'medium',
            grid_data: [
              {
                type: 'select',
                searchable: true,
                disabled: buyHealthPolicy?.proposalNumber?.length > 0,
                label: (
                  <div>
                    Previous Insurer Name{' '}
                    {getDomainData(
                      businessTypeList,
                      buyHealthPolicy?.quotationType,
                      'code',
                      'value',
                    )?.toLowerCase() !== 'new business' ||
                    Object.keys(
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails,
                    ).find(
                      (k) =>
                        k?.toLowerCase() !== 'prevclaimlodged' &&
                        k?.toLowerCase() !== 'insuredrelationship' &&
                        k?.toLowerCase() !== 'cbpct' &&
                        values[`${nominee.relationship}`]
                          .prevInsuranceDetails[k],
                    ) ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
                name: `${nominee.relationship}.prevInsuranceDetails.prevInsurerName`,
                data:
                  rolloverCompanyList &&
                  rolloverCompanyList?.length > 0
                    ? rolloverCompanyList?.map((company) => {
                        return {
                          label: company.value ? company.value : '',
                          value: company.code ? company.code : '',
                        };
                      })
                    : [],
              },
              {
                type: 'text',
                disabled: buyHealthPolicy?.proposalNumber?.length > 0,
                label: (
                  <div>
                    Previous Policy Number{' '}
                    {getDomainData(
                      businessTypeList,
                      buyHealthPolicy?.quotationType,
                      'code',
                      'value',
                    )?.toLowerCase() !== 'new business' ||
                    Object.keys(
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails,
                    ).find(
                      (k) =>
                        k?.toLowerCase() !== 'prevclaimlodged' &&
                        k?.toLowerCase() !== 'insuredrelationship' &&
                        k?.toLowerCase() !== 'cbpct' &&
                        values[`${nominee.relationship}`]
                          .prevInsuranceDetails[k],
                    ) ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
                name: `${nominee.relationship}.prevInsuranceDetails.prevPolicyNo`,
              },
              {
                type: 'number',
                onKeyDown: (evt) =>
                  (evt.key === 'e' || evt.key === '-') &&
                  evt.preventDefault(),
                iconPre: <FontAwesomeIcon icon={faRupeeSign} />,
                disabled: buyHealthPolicy?.proposalNumber?.length > 0,
                className:
                  buyHealthPolicy?.proposalNumber.length > 0
                    ? `border-neutral-dark`
                    : ``,
                label: (
                  <div>
                    Sum Insured{' '}
                    {getDomainData(
                      businessTypeList,
                      buyHealthPolicy?.quotationType,
                      'code',
                      'value',
                    )?.toLowerCase() !== 'new business' ||
                    Object.keys(
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails,
                    ).find(
                      (k) =>
                        k?.toLowerCase() !== 'prevclaimlodged' &&
                        k?.toLowerCase() !== 'insuredrelationship' &&
                        k?.toLowerCase() !== 'cbpct' &&
                        values[`${nominee.relationship}`]
                          .prevInsuranceDetails[k],
                    ) ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
                name: `${nominee.relationship}.prevInsuranceDetails.prevPolicySI`,
              },
              {
                type: 'date',
                disabled: buyHealthPolicy?.proposalNumber?.length > 0,
                label: (
                  <div>
                    Policy Start Date{' '}
                    {getDomainData(
                      businessTypeList,
                      buyHealthPolicy?.quotationType,
                      'code',
                      'value',
                    )?.toLowerCase() !== 'new business' ||
                    Object.keys(
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails,
                    ).find(
                      (k) =>
                        k?.toLowerCase() !== 'prevclaimlodged' &&
                        k?.toLowerCase() !== 'insuredrelationship' &&
                        k?.toLowerCase() !== 'cbpct' &&
                        values[`${nominee.relationship}`]
                          .prevInsuranceDetails[k],
                    ) ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
                name: `${nominee.relationship}.prevInsuranceDetails.prevPolicyStartDate`,
              },
              {
                type: 'date',
                disabled: buyHealthPolicy?.proposalNumber?.length > 0,
                label: (
                  <div>
                    Policy Expiry Date{' '}
                    {getDomainData(
                      businessTypeList,
                      buyHealthPolicy?.quotationType,
                      'code',
                      'value',
                    )?.toLowerCase() !== 'new business' ||
                    Object.keys(
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails,
                    ).find(
                      (k) =>
                        k?.toLowerCase() !== 'prevclaimlodged' &&
                        k?.toLowerCase() !== 'insuredrelationship' &&
                        k?.toLowerCase() !== 'cbpct' &&
                        values[`${nominee.relationship}`]
                          .prevInsuranceDetails[k],
                    ) ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
                name: `${nominee.relationship}.prevInsuranceDetails.prevPolicyEndDate`,
                onDataChange: (val, setFieldValue) => {
                  setFieldValue(
                    `${nominee.relationship}.prevInsuranceDetails.prevPolicyStartDate`,
                    moment(val,"DD/MM/YYYY").subtract(1, 'year').add(1,'days').format('DD/MM/YYYY')
                  );},
              },
              {
                type: 'select',
                disabled: buyHealthPolicy?.proposalNumber?.length > 0,
                label: (
                  <div>
                    Claims lodged in past policy?{' '}
                    {getDomainData(
                      businessTypeList,
                      buyHealthPolicy?.quotationType,
                      'code',
                      'value',
                    )?.toLowerCase() !== 'new business' ||
                    Object.keys(
                      values[`${nominee.relationship}`]
                        .prevInsuranceDetails,
                    ).find(
                      (k) =>
                        k?.toLowerCase() !== 'prevclaimlodged' &&
                        k?.toLowerCase() !== 'insuredrelationship' &&
                        k?.toLowerCase() !== 'cbpct' &&
                        values[`${nominee.relationship}`]
                          .prevInsuranceDetails[k],
                    ) ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
                name: `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
                data: [
                  {
                    label: 'Yes',
                    value: 'Yes',
                  },
                  {
                    label: 'No',
                    value: 'No',
                  },
                ],
                onDataChange: (val, setFieldValue) => {
                  if (val?.toLowerCase() !== 'yes') {
                    setFieldValue(
                      `${nominee.relationship}.prevInsuranceDetails.claimAmount`,
                      '',
                    );
                    setFieldValue(
                      `${nominee.relationship}.prevInsuranceDetails.cbAmount`,
                      '',
                    );
                  }
                },
              },
              {
                type: 'number',
                name: `${nominee.relationship}.prevInsuranceDetails.claimAmount`,
                disabled:
                buyHealthPolicy?.proposalNumber?.length > 0 ||
                !(
                  values[
                    `${nominee.relationship}`
                  ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                  'yes'
                ),
                  onKeyDown: (evt) =>
                  (evt.key === 'e' || evt.key === '-') &&
                  evt.preventDefault(),
                  iconPre: (
                    <Text
                      severity={`${
                        buyHealthPolicy?.proposalNumber?.length > 0 ||
                        !(
                          values[
                            `${nominee.relationship}`
                          ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                          'yes'
                        )
                          ? 'neutral'
                          : 'info'
                      }`}
                    >
                      {branding.currency}
                    </Text>
                  ),
                  onDataChange: (val, setFieldValue) => {
                    if (
                      !val &&
                      !values[`${nominee.relationship}`]
                        ?.prevInsuranceDetails?.cbAmount
                    ) {
                      setFieldValue(
                        `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
                        '',
                      );
                    } else {
                      if (
                        !values[`${nominee.relationship}`]
                          ?.prevInsuranceDetails?.prevClaimLodged
                      ) {
                        setFieldValue(
                          `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
                          'YES',
                        );
                      }
                    }
                  }, 
                                 className:
                                 buyHealthPolicy?.proposalNumber?.length > 0 ||
                                 !(
                                   values[
                                     `${nominee.relationship}`
                                   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                                   'yes'
                                 )
                                                     ? `border-neutral-dark`
                    : ``,
                label: (
                  <div>
                    Claim Amount{' '}
                    {values[
                      `${nominee.relationship}`
                    ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                    'yes' ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )}
                  </div>
                ),
              },
              // removed the code for cummulative bonus
              {
                type: 'number',
                min: 0,
                name: `${nominee.relationship}.prevInsuranceDetails.cbAmount`,
                disabled:
                  buyHealthPolicy?.proposalNumber?.length > 0,
                  // !(
                  //   values[
                  //     `${nominee.relationship}`
                  //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                  //   'yes'
                  // ),
                                  onKeyDown: (evt) =>
                  (evt.key === 'e' || evt.key === '-') &&
                  evt.preventDefault(),
                  iconPre: (
                    <Text
                      severity={`${
                        buyHealthPolicy?.proposalNumber?.length > 0 
                        // !(
                        //   values[
                        //     `${nominee.relationship}`
                        //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                        //   'yes'
                        // )
                          ? 'neutral'
                          : 'info'
                      }`}
                    >
                      {branding.currency}
                    </Text>
                  ),
                  onDataChange: (val, setFieldValue) => {
                    // if (
                    //   !val &&
                    //   !values[`${nominee.relationship}`]
                    //     ?.prevInsuranceDetails?.claimAmount
                    // ) {
                    //   setFieldValue(
                    //     `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
                    //     '',
                    //   );
                    // } else {
                    //   if (
                    //     !values[`${nominee.relationship}`]
                    //       ?.prevInsuranceDetails?.prevClaimLodged
                    //   ) {
                    //     setFieldValue(
                    //       `${nominee.relationship}.prevInsuranceDetails.prevClaimLodged`,
                    //       'YES',
                    //     );
                    //   }
                    // }
                  },
                  className:
                  buyHealthPolicy?.proposalNumber?.length > 0 
                  // !(
                  //   values[
                  //     `${nominee.relationship}`
                  //   ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                  //   'yes'
                  // )
                    ? `border-neutral-dark`
                    : ``,
                label: (
                  <div>
                    Cummulative Bonus Amount{' '}
                    {/* {values[
                      `${nominee.relationship}`
                    ].prevInsuranceDetails.prevClaimLodged?.toLowerCase() ===
                    'yes' ? (
                      <Text severity="error">*</Text>
                    ) : (
                      <Text></Text>
                    )} */}
                  </div>
                ),
              } ,
            ],
          };
        })
      : [];

    const otherPropsWithoutExpanded = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
    };

    const data = nomineeDetails
      ? nomineeDetails.map((m, idx) => {
          return {
            title: (
              <>
                <Text severity="info" type="large">
                  {m.relationship}-Nominee{' '}
                </Text>
                <Text severity="error" type="title">
                  *
                </Text>
              </>
            ),
            size: 'medium',
            grid_data: [
              {
                type: 'text',
                label: (
                  <div>
                    Name <Text severity="error">*</Text>
                  </div>
                ),
                name: `${m.relationship}.name`,
                disabled:
                  buyHealthPolicy?.proposalNumber.length > 0 ||
                  (values.sameNomineeForAllInsured && idx > 0),
                onDataChange: (val, setFieldValue) => {
                  setFieldValue(
                    `${m.relationship}.dob`,
                    moment().subtract(18, 'years').format('DD/MM/YYYY').toString()
                  );
                  if (values.sameNomineeForAllInsured && idx === 0) {
                    nomineeDetails
                      .filter(
                        (nominee) =>
                          nominee.relationship.toLowerCase() !==
                          m.relationship.toLowerCase(),
                      )
                      .forEach((nominee) => {
                        setFieldValue(
                          `${nominee.relationship}.name`,
                          val,
                        );
                      });
                  }
                },
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
              },
              {
                type: 'date',
                label: (
                  <div>
                    Date of Birth <Text severity="error">*</Text>
                  </div>
                ),
                name: `${m.relationship}.dob`,
                disabled:
                  buyHealthPolicy?.proposalNumber.length > 0 ||
                  (values.sameNomineeForAllInsured && idx > 0),
                onDataChange: (val, setFieldValue) => {
                  if (
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(val, 'DD/MM/YYYY'),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE
                  ) {
                    setFieldValue(
                      `${m.relationship}.nameOfAppointee`,
                      '',
                    );
                    setFieldValue(
                      `${m.relationship}.relationshipWithAppointee`,
                      '',
                    );
                  }
                  if (values.sameNomineeForAllInsured && idx === 0) {
                    nomineeDetails
                      .filter(
                        (nominee) =>
                          nominee.relationship.toLowerCase() !==
                          m.relationship.toLowerCase(),
                      )
                      .forEach((nominee) => {
                        setFieldValue(
                          `${nominee.relationship}.dob`,
                          val,
                        );
                        if (
                          moment(new Date(), 'DD/MM/YYYY').diff(
                            moment(val, 'DD/MM/YYYY'),
                            'years',
                          ) >= MINOR_THRESHOLD_AGE
                        ) {
                          setFieldValue(
                            `${nominee.relationship}.nameOfAppointee`,
                            '',
                          );
                          setFieldValue(
                            `${nominee.relationship}.relationshipWithAppointee`,
                            '',
                          );
                        }
                      });
                  }
                },
              },
              {
                type: 'select',
                label: (
                  <div>
                    Relationship with Member{' '}
                    <Text severity="error">*</Text>
                  </div>
                ),
                data: PRD_NomiRelationWithMemb
                  ? [
                      ...PRD_NomiRelationWithMemb.map(
                        (relationshipWithMember) => {
                          return {
                            label: relationshipWithMember.value
                              ? relationshipWithMember.value
                              : '',
                            value: relationshipWithMember.code
                              ? relationshipWithMember.code
                              : '',
                          };
                        },
                      ),
                    ]
                  : [],
                name: `${m.relationship}.relationshipWithInsured`,
                disabled: buyHealthPolicy?.proposalNumber.length > 0,
              },
              {
                type: 'text',
                label: 'Name of Appointee (in case of Minor)',
                name: `${m.relationship}.nameOfAppointee`,
                onDataChange: (val, setFieldValue) => {
                  if (values.sameNomineeForAllInsured && idx === 0) {
                    nomineeDetails
                      .filter(
                        (nominee) =>
                          nominee.relationship.toLowerCase() !==
                          m.relationship.toLowerCase(),
                      )
                      .forEach((nominee) => {
                        setFieldValue(
                          `${nominee.relationship}.nameOfAppointee`,
                          val,
                        );
                      });
                  }
                },
                onKeyDown: (evt) => {
                  if (
                    (evt?.target?.value?.toString()?.endsWith(' ') &&
                      evt?.key === ' ') ||
                    (evt?.target?.value?.toString()?.length === 0 &&
                      evt?.key === ' ')
                  ) {
                    evt.preventDefault();
                  }
                },
                disabled:
                  buyHealthPolicy?.proposalNumber.length > 0 ||
                  moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(
                      values[`${m.relationship}`].dob,
                      'DD/MM/YYYY',
                    ),
                    'years',
                  ) >= MINOR_THRESHOLD_AGE ||
                  (values.sameNomineeForAllInsured && idx > 0),
              },
              {
                type: 'select',
                label: 'Relationship with Nominee',
                searchable: true,
                data: PRD_ApointRelationWithMinNomi
                  ? [
                      ...PRD_ApointRelationWithMinNomi.map(
                        (relationshipWithAppointee) => {
                          return {
                            label: relationshipWithAppointee.value
                              ? relationshipWithAppointee.value
                              : '',
                            value: relationshipWithAppointee.code
                              ? relationshipWithAppointee.code
                              : '',
                          };
                        },
                      ),
                    ]
                  : [],
                name: `${m.relationship}.relationshipWithAppointee`,
                disabled:
                  buyHealthPolicy?.proposalNumber.length > 0 ||
                  moment(new Date(), 'DD/MM/YYYY').diff(
                    moment(
                      values[`${m.relationship}`].dob,
                      'DD/MM/YYYY',
                    ),
                    'years',
                  ) >= MINOR_THRESHOLD_AGE,
              },
              idx === 0 && nomineeDetails.length > 1
                ? {
                    type: 'checkbox',
                    name: 'sameNomineeForAllInsured',
                    disabled:
                      buyHealthPolicy?.proposalNumber.length > 0,
                    label: 'Same Nominee for all members?',
                    colSpan: repeat,
                    onDataChange: (val, setFieldValue) => {
                      if (val) {
                        nomineeDetails
                          .filter(
                            (nominee) =>
                              nominee.relationship.toLowerCase() !==
                              m.relationship,
                          )
                          .forEach((nominee) => {
                            setFieldValue(
                              `${nominee.relationship}.name`,
                              values[`${m.relationship}`].name,
                            );
                            setFieldValue(
                              `${nominee.relationship}.dob`,
                              values[`${m.relationship}`].dob,
                            );
                            setFieldValue(
                              `${nominee.relationship}.nameOfAppointee`,
                              values[`${m.relationship}`]
                                .nameOfAppointee,
                            );
                          });
                        } else {
                          nomineeDetails
                            .filter(
                              (nominee) =>
                                nominee.relationship.toLowerCase() !==
                                m.relationship?.toLowerCase(),
                            )
                            .forEach((nominee) => {
                              setFieldValue(
                                `${nominee.relationship}.name`,
                                '',
                              );
                              setFieldValue(
                                `${nominee.relationship}.dob`,
                                '',
                              );
                              setFieldValue(
                                `${nominee.relationship}.nameOfAppointee`,
                                '',
                              );
                            });
                      }
                    },
                  }
                : null,
            ].filter((d) => d),
          };
        })
      : [];

    const other_props = {
      flow: 'cols',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };

    return (
      <>
        <QuantaForm className="-space-y-2 mt-3">
          <InputGridGroup {...{ data, ...other_props }} />
          <div className="flex flex-col space-y-4">
            <Text severity="info" type="title" className="mt-6">
              Previous Insurance Details
            </Text>
            <InputGridGroup
              {...{ data: prevInsuredDetailsData, ...other_props }}
            />
          </div>
          <div className="flex flex-col space-y-4">
            <Text severity="info" type="title" className="mt-6">
              Renew Mandate Details
            </Text>
            <InputGridGroup
              {...{
                data: renewalMandateDetails,
                ...other_props,
              }}
            />
          </div>
          <InputGridGroup
            {...{
              data: healthDeclarationData,
              ...otherPropsWithoutExpanded,
            }}
          />
          <Button
            type="button"
             disabled={values.isHealthDeclarationSelected === 'No'}
            flat={true}
            iconPre={
              <FontAwesomeIcon
                icon={faFileMedical}
                className={
                  values.isHealthDeclarationSelected === 'No'
                    ? 'mr-1'
                    : 'ml-2 mr-1'
                }
              />
            }
            onClick={(_) => setMedicalQuestionaireDisplay(true)}
          >
            {' '}
            Medical Questionaire
          </Button>
          <div>
            <NotificationList {...{ items: alerts }} />
          </div>
        </QuantaForm>
        <SearchResultsModal
          {...{
            modalDisplay: ifscModalDisplay,
            searchInput,
            searchResults,
            paginationInput,
            title: 'Search IFSC Code',
            onClose,
            onDataUpdate,
            onNoResultsFound,
            onMessage,
            selectOnRowClick: true,
            firstRowClickRequired: false,
          }}
        />
      </>
    );
  };

  const submitNomineeArr = (values) => {
    let submitArr = [];
    let prevInsuredArr = [];
    Object.keys(values).forEach((m) => {
      if (typeof values[m] === 'object') {
        const { prevInsuranceDetails, ...restValues } = values[m];
        submitArr.push({
          relationship: m,
          ...restValues,
        });
        prevInsuredArr.push(prevInsuranceDetails);
      }
    });
    return {
      nomineeDetails: submitArr,
      prevInsuranceDetails: prevInsuredArr,
      sameNomineeForAllInsured: values.sameNomineeForAllInsured,
      isHealthDeclarationSelected: values.isHealthDeclarationSelected,
      renewalMandateDetails: {
        renewalPaymentMandate: values.renewalPaymentMandate,
        renewalPaymentMandateTakenInNameOf:
          values.renewalPaymentMandateTakenInNameOf,
        termForMandateOpted: values.termForMandateOpted,
        typeOfDebit: values.typeOfDebit,
        accountNumber: values.accountNumber,
        destinationBankName: values.destinationBankName,
        destinationIfscCode: values.destinationIfscCode,
        destinationMicrCode: values.destinationMicrCode,
        destinationBranchName: values.destinationBranchName,
        mandateAmount: renew_man_amount,
        finalCollectionDate: values.finalCollectionDate,
        destinationBankAccountType: values.destinationBankAccountType,
      },
    };
  };

  const calculatePremiumForProposalVariables = (
    buyHealthPolicyData,
    getDateTimeData,
    values,
  ) => {
    const getInsuredDetailsObj = (
      insuredDetails,
      medicalQuestionaire,
      planData,
      isHealthDeclarationSelected,
    ) => {
      const { nomineeDetails } = submitNomineeArr(values);
      let insuredDetailsResponseArr = [];
      insuredDetails.forEach((insured) => {
        const {
          ppcTestLevel,
          memberID,
          memberStatus,
          ...restInsured
        } = insured;
        let insuredObj = { ...restInsured };

        const nomineeObj = nomineeDetails?.find(
          (nominee) =>
            nominee?.relationship?.toLowerCase() ===
            insured?.relationship?.toLowerCase(),
        );
        const { relationship, ...restNomineeObj } = nomineeObj;
        insuredObj.nomineeDetails = {
          ...restNomineeObj,
          insuredRelationship: relationship,
        };
        const prevInsuranceInput =
          values[insured?.relationship]?.prevInsuranceDetails;

        insuredObj.prevInsuranceInput = {
          prevInsurerName: prevInsuranceInput?.prevInsurerName,
          prevPolicyNo: prevInsuranceInput?.prevPolicyNo,
          prevPolicySI: prevInsuranceInput?.prevPolicySI,
          prevClaimLodged:
            prevInsuranceInput?.prevClaimLodged?.toLowerCase() ===
            'yes'
              ? true
              : false,
          claimAmount: prevInsuranceInput?.claimAmount,
          prevPolicyStartDate:
            prevInsuranceInput?.prevPolicyStartDate,
          prevPolicyEndDate: prevInsuranceInput?.prevPolicyEndDate,
          cbAmount: prevInsuranceInput?.cbAmount,
        };

        let medicalQuestionaireObj = isHealthDeclarationSelected
          ? medicalQuestionaire?.find(
              (m) =>
                m?.relationship?.toLowerCase() ===
                insured?.relationship?.toLowerCase(),
            )
          : { relationship: insured?.relationship, questions: [] };

        if (
          medicalQuestionaireObj &&
          medicalQuestionaireObj?.questions?.length > 0
        ) {
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions: medicalQuestionaireObj?.questions?.map(
              (question) => {
                return {
                  srNo: question?.srNo,
                  answer: question?.answer?.answerText,
                };
              },
            ),
          };
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions:
              medicalQuestionaireObj?.questions
                ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                ?.answer?.toLowerCase() !== 'ye'
                ? medicalQuestionaireObj?.questions?.filter(
                    (q) => q?.srNo?.toLowerCase() !== '',
                  )
                : [],
          };
        }
        insuredObj.medicalQuestionaire = medicalQuestionaireObj
          ? medicalQuestionaireObj
          : { relationship: insured?.relationship, questions: [] };

        const { plans } = planData;
        insuredObj.addOnCovers = plans
          ?.find(
            (p) =>
              p?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )
          ?.packs?.filter((pack) =>
            pack?.index?.includes(insured?.relationship),
          )
          .flatMap((pack) =>
            pack.addOnCovers.filter(
              (addOnCover) => addOnCover.selected,
            ),
          );
        if (!insuredObj.addOnCovers) {
          insuredObj.addOnCovers = [];
        }

        insuredDetailsResponseArr.push(insuredObj);
      });
      let enddatevalue = insuredDetailsResponseArr[0]?.prevInsuranceInput?.prevPolicyEndDate;
      for (let i = 0; i <= insuredDetailsResponseArr.length; i++) {
        if (moment(enddatevalue, 'DD/MM/YYYY').isAfter(
          moment(insuredDetailsResponseArr[i]?.prevInsuranceInput?.prevPolicyEndDate,
            'DD/MM/YYYY'),'dates')) {
          enddatevalue = insuredDetailsResponseArr[i]?.prevInsuranceInput?.prevPolicyEndDate;
	   }else if ( !enddatevalue ){
        
         enddatevalue = insuredDetailsResponseArr[i]?.prevInsuranceInput?.prevPolicyEndDate;
        }
      }
      enddatevalue= moment(enddatevalue,"DD/MM/YYYY").add(1,'days').format('DD/MM/YYYY')
      policy_Start_Date_min=enddatevalue;
      return insuredDetailsResponseArr;
    };
    // const { crn,isNewCustomer, ...restProposerMetaData }
    const { isNewCustomer,isCRNVerified, ...restProposerMetaData } =
      buyHealthPolicyData?.proposerDetailsMeta;
    const { warningMsg, ...restPremium } =
     buyHealthPolicyData?.planData?.plans?.find(
            (plan) =>
              plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          )?.premium;
    return {
      input: {
        proposerDetails: {
          ...restProposerMetaData,
          ...buyHealthPolicyData?.proposerDetails,
          isThinCustomer: false,
          isCRNVerified : isCRNVerified === null ? false : 
                isCRNVerified === "" ? false: isCRNVerified,
        },
        insuredDetails: getInsuredDetailsObj(
          buyHealthPolicyData?.insuredDetails,
          buyHealthPolicyData?.medicalQuestionaire,
          buyHealthPolicyData?.planData,
          values?.isHealthDeclarationSelected?.toLowerCase() !==
            'ye',
        ),
        plan: {
          name: plan_name,
          code: plan_code,
          premium:restPremium,
          // premium: buyHealthPolicyData?.planData?.plans?.find(
          //   (plan) =>
          //     plan?.name?.toLowerCase() === plan_name?.toLowerCase(),
          // )?.premium,
        },
        intermediary: {
          intermediaryCode:
            buyHealthPolicyData?.intermediaryDetails?.code,
          locationCode:
            buyHealthPolicyData?.intermediaryDetails?.location,
          fieldUserCode:
            buyHealthPolicyData?.intermediaryDetails?.fieldUserCode,
        },
        zone: buyHealthPolicyData?.quoteData?.location?.zone?.trim(),
        quotationType: buyHealthPolicyData?.quotationType,
        sumInsured: parseFloat(
          buyHealthPolicyData?.quoteData?.cover?.sum_insured,
        ),
        deductSumInsured: parseFloat(
          buyHealthPolicyData?.quoteData?.deductSumInsured,
        ),
        startDate: buyHealthPolicyData?.quotationType?.toLowerCase()==='roll over'
        ?policy_Start_Date_min// buyHealthPolicy?.policy?.startDate
        :getDateTimeData?.datetimeValue?.date,
        startTime: '00:00',
        tenure: buyHealthPolicyData?.quoteData?.cover?.tenure,
        coverType: buyHealthPolicyData?.quoteData?.cover?.type,
        isHealthDeclarationSelected:
          values?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes' ,
        productCode: product_code,
        isExistingEmployee:
          buyHealthPolicy?.quoteData?.isExistingEmployee?.toLowerCase() ===
          'yes'
            ? true
            : false,
        existingPolicyNumber:
          buyHealthPolicyData?.existingPolicyNumber,
        employeeNumber:
          buyHealthPolicyData?.proposerDetails?.employeeNumber,
        proposerPincode:
          buyHealthPolicyData?.quoteData?.location?.pincode,
        renewalMandateDetails: {
          renewalPaymentMandate: values?.renewalPaymentMandate,
          renewalPaymentMandateTakenInNameOf:
            values?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted: values?.termForMandateOpted,
          typeOfDebit: values?.typeOfDebit,
          accountNumber: values?.accountNumber,
          destinationBankName: values?.destinationBankName,
          destinationIfscCode: values?.destinationIfscCode,
          destinationMicrCode: values?.destinationMicrCode,
          destinationBranchName: values?.destinationBranchName,
          mandateAmount: parseFloat(renew_man_amount),
          finalCollectionDate: values?.finalCollectionDate,
          destinationBankAccountType:
            values?.destinationBankAccountType,
        },
      },
    };
  };

  const onSubmit = async (values) => {
    if (Object.values(validate(values)).length === 0) {
      if (buyHealthPolicy?.proposalNumber?.length > 0) {
        setProceedToNextStep([
          ...proceedToNextStep.slice(0, 2),
          true,
          ...proceedToNextStep.slice(3),
        ]);
        return true;
      }
      try {
        let getDateTime = fetchQuery({
          query: GET_DATE_TIME,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setCustomLoadingMessage('Calculating Premium');
        setLoadingStep(true);
        let { data: getDateTimeData } = await getDateTime;
        let calculatePremiumForProposal = fetchQuery({
          query: CALCULATE_PREMIUM_FOR_PROPOSAL,
          variables: calculatePremiumForProposalVariables(
            buyHealthPolicy,
            getDateTimeData,
            values,
          ),
        });
        let { data } = await calculatePremiumForProposal;
        setLoadingStep(false);
        setCustomLoadingMessage(null);
        if (data?.calculatePremiumForProposal?.warningMsg) {
          if (
            buyHealthPolicy?.planData?.plans
              ?.find((p) => p.name === planName)
              ?.premium?.totalPremium?.toString() !==
            data?.calculatePremiumForProposalST?.totalPremium?.toString()
          ) {
            setParentAlerts([
              {
                id: 1,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      Your premium has been updated successfully
                    </Text>
                  </div>
                ),
                type: 'info',
                timeout: null,
                disableClose: false,
              },
              {
                id: 2,
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {data?.calculatePremiumForProposalST?.warningMsg}
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          } else {
            setParentAlerts([
              {
                id: Date.now(),
                content: (
                  <div className="flex flex-col w-full h-full">
                    <Text type="normal">
                      {data?.calculatePremiumForProposalST?.warningMsg}
                    </Text>
                  </div>
                ),
                type: 'warning',
                timeout: null,
                disableClose: false,
              },
            ]);
          }
        } else {
          if (
            buyHealthPolicy?.planData?.plans
              ?.find((p) => p.name === planName)
              ?.premium?.totalPremium?.toString() !==
            data?.calculatePremiumForProposal?.totalPremium?.toString()
          ) {
        setParentAlerts([
          {
            id: Date.now(),
            content: (
              <div className="flex flex-col w-full h-full">
                <Text type="normal">
                  Your premium has been updated successfully
                </Text>
              </div>
            ),
            type: 'info',
            timeout: null,
            disableClose: false,
          },
        ]);
      } else {
        setParentAlerts([]);
      }
    }
        updateBuyHealthPolicy({
          ...submitNomineeArr(values),
          insuredDetails: buyHealthPolicy?.insuredDetails?.map(
            (member) => {
              return {
                ...member,
                ppcTestLevel: data?.calculatePremiumForProposal?.breakup?.find(
                  (b) =>
                    b?.relationship?.toLowerCase() ===
                    member?.relationship?.toLowerCase(),
                )?.ppcTestLevel,
              };
            },
          ),
          policy: {
            startDate:buyHealthPolicy?.quotationType?.toLowerCase()==='roll over'
            ? policy_Start_Date_min
            :"" ,
            endDate: '',
            time: '',
          },
        });
        updatePlanPremium(
          plan_name,
          data.calculatePremiumForProposalST,
        );
        setProceedToNextStep([
          ...proceedToNextStep.slice(0, 2),
          true,
          ...proceedToNextStep.slice(3),
        ]);
        return true;
      } catch (error) {
        updateBuyHealthPolicy(submitNomineeArr(values));
        setParentAlerts([
          {
            header: 'Error',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                {error.message}
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingStep(false);
        return false;
      }
    }
    return false;
  };

  return (
    <div>
      <Text severity="info" type="title">
        Nominee Details
      </Text>
      <QuantaFormik
        innerRef={props.forwardedRef}
        enableReinitialize={true}
        {...{
          initialValues,
          validate,
          onSubmit,
          validator: () => ({}),
        }}
      >
        <NomineeForm
          {...{
            validate,
            medicalQuestionaireDisplay,
            setMedicalQuestionaireDisplay,
          }}
        />
      </QuantaFormik>
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
      <div>
        <ModalMedicalQuestionaire
          {...{
            productCode:product_code,
            medicalQuestionaireDisplay,
            setMedicalQuestionaireDisplay,
            questions: productQuestionList,
            readOnlyMode: buyHealthPolicy?.proposalNumber?.length > 0,
          }}
        />
      </div>
    </div>
  );
}
